module.exports = __webpack_public_path__ + "img/product-banner1.9c3a2660.png";